<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: [Array, Object],
      default: null,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  mounted() {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: this.title ? true : false,
        text: this.title,
      },

      legend: {
        position: "top",
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true, // Start the y-axis at zero
              stepSize: 1, // Ensure steps of 1 for whole numbers only
              callback: function (value) {
                if (Number.isInteger(value)) {
                  return value;
                }
                return null;
              },
            },
          },
        ],
      },
      onClick: this.handleClick,
    };
    this.renderChart(this.chartData, options);
  },
};
</script>
